<div class="row page-title-header modal-header header-class m-0">
  <div class="col-md-11 col-11 text-center">
    <span class="title">User Preferences</span>
  </div>
  <div class="col-md-1 col-1 pull-right p-0">
    <a class="close link" (click)="close()">&times;</a>
  </div>
</div>

<div style="padding: 20px 15px 0;">
  <!-- <mat-form-field style="width: 100%" appearance="outline" class="matFformFieldClient">
    <mat-label>Region</mat-label>
    <mat-select [(ngModel)]="selectedEnv" (selectionChange)="getClients()">
      <mat-option style="font-family: 'Poppins';" *ngFor="let env of envData" [value]="env">
        {{env.region_name }}
      </mat-option>
    </mat-select>
  </mat-form-field> -->

  <mat-form-field style="width: 100%" appearance="outline" class="matFformFieldClient">
    <mat-label>Clients</mat-label>
    <mat-select [(ngModel)]="selectedClient" (selectionChange)="getUserPreferrenceBrand()">
      <mat-option style="font-family: 'Poppins';" *ngFor="let client of clients" [value]="client">
        {{client.client_nm }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field style="width: 100%" appearance="outline" class="matFformFieldClient">
    <mat-label>Brands</mat-label>
    <mat-select [(ngModel)]="selectedBrand">
      <mat-option style="font-family: 'Poppins';" *ngFor="let brand of brands" [value]="brand">
        {{brand.brand_nm }}
      </mat-option>
    </mat-select>
  </mat-form-field>


  <div class="row" style="width: 100%">
    <div class="col-lg-12 col-md-12 col-sm-12 text-center btn-align">
      <mat-dialog-actions class="ml-4">
        <button [disabled]="!selectedBrand" class="du-btn du-custom-confirm-btn confirm-btn" (click)="envSelection()"
          matTooltip="Confirm" matTooltipClass="expand-tooltip">
          Confirm
        </button>
      </mat-dialog-actions>
    </div>
  </div>
</div>